import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDeleteInteractionDictionaryMutation } from 'src/api/interactions-dictionary/hooks';
import { useGlobalModals } from 'src/contexts/global-modals';
import { routes } from 'src/router/routes';

export const useDeleteInteractionDictionary = () => {
  const {
    deleteInteractionDictionaryModal,
    closeDeleteInteractionDictionaryModal,
    openLoadingModal,
    closeLoadingModal,
  } = useGlobalModals();
  const { deleteInteractionDictionaryMutation, isPending } =
    useDeleteInteractionDictionaryMutation();
  const navigate = useNavigate();

  const open = deleteInteractionDictionaryModal.opened;
  const interactionDictionaryId =
    deleteInteractionDictionaryModal.interactionDictionaryId;

  const handleConfirm = useCallback(async () => {
    if (!interactionDictionaryId) {
      return;
    }

    openLoadingModal(
      'Deleting interaction dictionary',
      'Please wait while we delete the interaction dictionary...'
    );
    closeDeleteInteractionDictionaryModal();

    try {
      await deleteInteractionDictionaryMutation(interactionDictionaryId);
      navigate(routes.interactionsDictionary);
    } finally {
      closeLoadingModal();
    }
  }, [
    closeDeleteInteractionDictionaryModal,
    closeLoadingModal,
    deleteInteractionDictionaryMutation,
    interactionDictionaryId,
    navigate,
    openLoadingModal,
  ]);

  const handleClose = useCallback(() => {
    closeDeleteInteractionDictionaryModal();
  }, [closeDeleteInteractionDictionaryModal]);

  return {
    handleClose,
    handleConfirm,
    isPending,
    open,
  };
};
